import { TooltipWrapper } from 'components/TooltipWrapper';
import type { WorkOrderVorTypeEnum } from 'gql/graphql';
import { Button, cnMixSpace } from 'uikit';

import { useCallback, useRef, useState } from 'react';
import type React from 'react';

import { WorkOrderUploadModal } from '../WorkOrderUpload';

interface IUploadWorkOrder {
    workOrderId: number;
    vorType: WorkOrderVorTypeEnum | null | undefined;
    onSuccess: () => void;
    isDisabled?: boolean;
    onClose?: () => void;
    tooltipMessage: string;
}

export const UploadWorkOrder: React.FC<IUploadWorkOrder> = (props) => {
    const { workOrderId, onSuccess, isDisabled, onClose, vorType, tooltipMessage } = props;

    const buttonRef = useRef(null);

    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    const onButtonClick = useCallback(() => {
        setIsOpenModal(true);
    }, []);

    const onCloseLocal = useCallback(() => {
        if (onClose) {
            onClose();
        } else {
            setIsOpenModal(false);
        }
    }, [onClose]);

    const onSuccessLocal = useCallback(() => {
        onCloseLocal();
        onSuccess();
    }, [onCloseLocal, onSuccess]);

    return (
        <>
            <TooltipWrapper message={tooltipMessage} isInteractive={false} isHidden={!tooltipMessage}>
                <Button
                    className={cnMixSpace({ mR: 'xs' })}
                    label="Добавить ВОР"
                    view={isDisabled ? 'primary' : 'secondary'}
                    size="s"
                    onClick={onButtonClick}
                    disabled={isDisabled}
                    ref={buttonRef}
                />
            </TooltipWrapper>
            {isOpenModal && (
                <WorkOrderUploadModal
                    workOrderId={workOrderId}
                    onClose={onCloseLocal}
                    onSuccess={onSuccessLocal}
                    vorType={vorType}
                />
            )}
        </>
    );
};

UploadWorkOrder.displayName = 'UploadWorkOrder';
